import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import Debug from 'debug';
import { ITranslationsState } from '../interfaces/translations-state.interface';
import * as fromNotesTemplates from './notesTemplate.reducer';
import * as fromNotesTypes from './notesType.reducer';
import { createSelectors as translationSelectors, translationsReducer } from './translations.reducer';

const debug = Debug('aumico:aumico-lib-notes-fe:AumicoNotesReducer');

export const notesFeatureKey = 'aumicoNotesMicroservice';

// State Declarations - START

export interface FeatureState {
    notesTemplates: fromNotesTemplates.NotesTemplatesState;
    notesTypes: fromNotesTypes.NotesTypesState;
    translations?: ITranslationsState;
}

export interface AppState {
    aumicoNotesMicroservice: FeatureState;
}

export const reducers: ActionReducerMap<FeatureState> = {
    notesTemplates: fromNotesTemplates.reducer,
    notesTypes: fromNotesTypes.reducer,
    translations: translationsReducer,
};

// State Declarations - END
// Selectors Declarations - START
export const selectFeature = createFeatureSelector<FeatureState>(notesFeatureKey);

// notes templates selectors

export const selectNotesTemplatesState = createSelector(selectFeature, (state: FeatureState) => state.notesTemplates);
export const selectAllNotesTemplates = createSelector(
    selectNotesTemplatesState,
    fromNotesTemplates.selectAllNotesTemplates,
);
export const selectActiveNotesTemplateId = createSelector(
    selectNotesTemplatesState,
    fromNotesTemplates.getActiveNotesTemplateId,
);
export const selectActiveNotesTemplate = createSelector(
    selectNotesTemplatesState,
    fromNotesTemplates.getActiveNotesTemplate,
);

export const selectNotesTemplateById = createSelector(selectNotesTemplatesState, fromNotesTemplates.selectEntity);

export const selectNotesTemplateNameExistence = createSelector(
    selectNotesTemplatesState,
    fromNotesTemplates.nameExistenceSelector,
);

export const selectLegalFormAndAccountBasisExistence = createSelector(
    selectNotesTemplatesState,
    fromNotesTemplates.legalFormAndAccountBasisExistenceSelector,
);

export const selectNotesTemplateError = createSelector(
    selectNotesTemplatesState,
    fromNotesTemplates.getNotesTemplateError,
);

export const selectNotesTemplateByLegalFormAndAccountBasis = createSelector(
    selectNotesTemplatesState,
    fromNotesTemplates.getNotes,
);

// notes types selectors

export const selectNotesTypesState = createSelector(selectFeature, (state: FeatureState) => state.notesTypes);
export const selectAllNotesTypes = createSelector(selectNotesTypesState, fromNotesTypes.selectAllNotesTypes);
export const selectAllNotesTypesNamesAndIds = createSelector(
    selectNotesTypesState,
    fromNotesTypes.SelectAllNotesTypesNamesAndIds,
);
export const selectActiveNotesTypeId = createSelector(selectNotesTypesState, fromNotesTypes.getActiveNotesTypeId);
export const selectActiveNotesType = createSelector(selectNotesTypesState, fromNotesTypes.getActiveNotesType);

export const selectNotesTypeById = createSelector(selectNotesTypesState, fromNotesTypes.selectEntity);

export const selectNotesTypeNameExistence = createSelector(selectNotesTypesState, fromNotesTypes.nameExistenceSelector);

export const selectNotesTypeError = createSelector(selectNotesTypesState, fromNotesTypes.getNotesTypeError);

const selectTranslationsState = createSelector(selectFeature, (state) => state.translations);
export const translationsStateSelectors = translationSelectors(selectTranslationsState);

// Selectors Declarations - END
